import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export type DateTimePickerSize = 'sm' | 'md';

export interface DateTimePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  id?: string;
  name?: string;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  required?: boolean;
  size?: DateTimePickerSize;
  className?: string;
  showTime?: boolean;
  dateFormat?: string;
  isClearable?: boolean;
  timeIntervals?: number;
  autoComplete?: string;
}

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  onChange,
  id,
  name,
  placeholder,
  minDate,
  maxDate,
  disabled,
  required,
  size = 'md',
  className,
  showTime = true,
  dateFormat,
  isClearable = true,
  timeIntervals = 15,
  autoComplete = 'off',
}) => {
  const inputClassName = [
    'form-control',
    size === 'sm' ? 'form-control-sm' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  const resolvedFormat = dateFormat ?? (showTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd');

  return (
    <ReactDatePicker
      id={id}
      name={name}
      selected={value}
      onChange={onChange}
      placeholderText={placeholder}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      required={required}
      className={inputClassName}
      wrapperClassName="d-block"
      popperClassName="ss-datepicker-popper"
      calendarClassName="ss-datepicker-calendar"
      portalId="datepicker-portal"
      showTimeSelect={showTime}
      timeIntervals={timeIntervals}
      timeCaption="Time"
      dateFormat={resolvedFormat}
      isClearable={isClearable}
      autoComplete={autoComplete}
      shouldCloseOnSelect={!showTime}
    />
  );
};
